import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M10.02 20L10 13H7v-3h3V8c0-2.7 1.67-4 4.08-4 1.15 0 2.14.09 2.43.12v2.83h-1.67c-1.3 0-1.56.62-1.56 1.53V10H17l-1 3h-2.72v7h-3.26z" }));
export {
  o as ReactComponent
};
